export default class ShippingRates {
    static init(selector) {
        let $elementsToToggle = $('[show-if-freeshipping-selected]', selector);
        let $checkbox = $('#inputFreeShippingRate', selector);

        let toggle = () => $elementsToToggle.toggle($checkbox.prop('checked'));

        toggle();
        $checkbox.change(toggle);
    }
}
